<template>
	<div class="navigation">

		<div class="navigation-center">
			<div class="navigation-center__top">
				教师联盟读书会
			</div>

		</div>
		<!-- <span class='icon' :class="[!isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold']" @click="changeMenu"></span> -->
		<!-- <el-breadcrumb class="navigation-bread" separator="/">
			<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
			<el-breadcrumb-item v-for="(item, index) in breadList" :key="index">
				{{item.title}}
			</el-breadcrumb-item>
		</el-breadcrumb> -->
		<div class="navigation-right">
			<!-- <span class="navigation-right__name">{{ userInfo.name }}</span> -->
			<el-dropdown @command="handleCommand">
				<span>
					<span
						class="navigation-right__header"
					>
						{{userInfo.name}}
					</span>
					<i class="el-icon-arrow-down el-icon--right"></i>
				</span>
				<el-dropdown-menu slot="dropdown">
					<!-- <el-dropdown-item command="userinfo">修改头像</el-dropdown-item> -->
					<el-dropdown-item command="logout">退出登录</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
		</div>
	</div>
</template>

<script type="text/javascript">
import {
	logout
} from '@/api/common';
import Vuex from 'vuex';
export default {
	data() {
		return {
			realname: ''
		};
	},
	computed: {
		...Vuex.mapState({
			isCollapse: (state) => state.isCollapse,
			userInfo: (state) => state.userInfo
		}),
		breadList() {
			return this.$route.meta.bread || [];
		}
	},
	mounted() {

	},
	methods: {
		
		handleCommand(type) {
			switch (type) {
				case 'logout':
					this.loginOut()
					break;
				case 'userinfo':
					this.$router.push('/header');
					break;
			}
		},
		loginOut() {
			this.$confirm('您确认要退出系统吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
            	this.$store.commit('updateToken', {token: null});
        		window.location.href = '/login'
            });
		}
	}
};
</script>
<style lang="less">

.navigation {
	flex: 0 0 62px;
	height: 62px;
	background: #409EFF;
	box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
	display: flex;
	align-items: center;
	color: white !important;
	padding: 0 15px;
	
	&-title {
		font-family: '微软雅黑' !important;
	    font-size: 22px;
	    font-weight: bold;
	    color: white;
	    margin-left: 15px;
	    flex: 0 0 128px;
	    width: 128px;
	}
	&-logo {
		flex: 0 0 41px;
		width: 41px;
		height: 48px;
		position: relative;
		.cu5 {
			width: 100% !important;
			height: 100% !important;
			position: absolute;
			left: 0;
			top: 0;
		}
		.cu6 {
			width: 29px !important;
			height: 37px !important;
		}
		.cu7 {
			width: 4px !important;
			height: 6px !important;
			position: absolute;
			left: 21px;
			top: 21px;
		}
	}
	&-center {
		flex: 1;
	    color: white;
	    margin-left: 20px;
	    &__top {
	    	width: 200px;
	    	position: relative;
	    	margin-bottom: 3px;
	    	span {
	    		position: relative;
	    		margin-left: 30px;
	    		z-index: 9;
    		    font-weight: 400;
			    font-style: normal;
			    font-size: 12px;
			    padding: 0 10px;
			    background: #0050ad;
	    	}
	    	i {
	    		width: 100%;
	    		position: absolute;
	    		border-top: 1px solid white;
	    		left: 0;
	    		top: 7px;
	    		&.i2 {
	    			width: 90%;
	    			left: 10px;
	    			top: 10px;
	    		}
	    	}

	    }
	    &__bottom {
	    	text-shadow: 1px 1px 1px rgb(0 0 0);
	    	font-size: 16px;
	    	font-weight: 700;
	    }
	}

	&-bread {
		flex: 1;
		margin-left: 16px;
	}
	&-right {
		display: flex;
		align-items: center;
		color: #ffffff !important;
		&__name {
			font-weight: 400;
			color: #ffffff;
			margin-right: 10px;
		}
		&__header {
			display: inline-block;
			background-repeat: no-repeat;
			background-size: cover;
			background-position: center center;
			cursor: pointer;
			color: #ffffff;
		}
		.el-icon-arrow-down {
			color: white;
		}
	}
}
</style>
